import * as React from "react";
import { cn } from "../lib/utils";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "../primitive/empty";

export function EmptyState({
  className,
  title,
  description,
}: {
  className?: string;
  title: string;
  description: string;
}) {
  return (
    <Empty className={cn("rounded-xl border border-dashed border-border/80 bg-muted/35 px-4 py-4", className)}>
      <EmptyHeader className="items-start text-left">
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
